import { render, staticRenderFns } from "./CuratedRtqInstrumentsPieChart.vue?vue&type=template&id=38f7f5a7&scoped=true"
import script from "./CuratedRtqInstrumentsPieChart.vue?vue&type=script&lang=ts"
export * from "./CuratedRtqInstrumentsPieChart.vue?vue&type=script&lang=ts"
import style0 from "./CuratedRtqInstrumentsPieChart.vue?vue&type=style&index=0&id=38f7f5a7&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "38f7f5a7",
  null
  
)

export default component.exports